// extracted by mini-css-extract-plugin
var _1 = "Search_fluid__a9b03";
var _2 = "Search_root__a756b";
export { _1 as "fluid", _2 as "root" }
